import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import Avatar from 'material-ui/Avatar';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import { ToolbarGroup } from 'material-ui/Toolbar';
import Search from 'material-ui/svg-icons/action/search';
import Message from 'material-ui/svg-icons/communication/message';
import Menu from 'material-ui/svg-icons/navigation/menu';
import VoiceChat from 'material-ui/svg-icons/notification/voice-chat';
import PictureAsPdf from 'material-ui/svg-icons/image/picture-as-pdf';
import Dashboard from 'material-ui/svg-icons/action/dashboard';
import DateRange from 'material-ui/svg-icons/action/date-range';
import Timer from 'material-ui/svg-icons/image/timer';
import Assessment from 'material-ui/svg-icons/action/assessment';
import LibraryBooks from 'material-ui/svg-icons/av/library-books';
import School from 'material-ui/svg-icons/social/school';
import Notifications from 'material-ui/svg-icons/social/notifications'
import Add from 'material-ui/svg-icons/content/add';
import Schedule from 'material-ui/svg-icons/action/schedule';
import classnames from 'classnames'
import { logoutUser } from '../components/auth/auth_actions';
import { toggleNav, toggleNavResize, initialNav } from '../common/common_actions';
import DocumentSearchModal from './documentSearchModal';
import DirectMessages from './directmessagemodal';

class TopNavbar extends Component {
  constructor() {
    super();
    this.state = { showDocSearch: false, showMessages: false };
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentDidMount() {
    this.props.initialNav();
  }

  handleToggleDocSearch = () => { this.setState({ showDocSearch: !this.state.showDocSearch}); }

  handleToggleDirectMessages = () => { this.setState({ showMessages: !this.state.showMessages}); }

  handleLogout = () => { this.props.logoutUser(); }

  handleToggle = () => { this.props.toggleNav(!this.props.navOpen); }

  handleToggleResize = (open, smallWindow) => { this.props.toggleNavResize(open, smallWindow); }

  render() {
    window.onresize = () => {
      if (this.props.smallWindow === false && window.innerWidth < 800 ) {
        this.handleToggleResize(false, true);
      } else if (this.props.smallWindow === true && window.innerWidth >= 800 ) {
        this.handleToggleResize(true, false);
      }
    }

    const { showDocSearch, showMessages } = this.state;

    return (
      <div>
        <AppBar
          title={<img src={require('../assets/mozak.png')} style={{ width: 120, marginBottom: 25 }} alt={'Logo'} />}
          className={classnames('app-bar', {'expanded': this.props.navOpen})}
          iconElementLeft={<IconButton style={{ top: -10}} ><Menu color={'#dddddd'} /></IconButton>}
          iconStyleLeft={{ marginBottom: 60 }}
          style={{ backgroundColor: '#333333', height: 50 }}
          onLeftIconButtonTouchTap={this.handleToggle}
          >

        <ToolbarGroup style={{ marginRight: 0 }}>
            <p style={{ marginTop: 10, fontSize: 12, marginRight: 5, color: '#eeeeee', fontWeight: 300 }}>
              {this.props.user.email}
            </p>

            <IconMenu
              iconButtonElement={
                <Avatar
                icon={!this.props.user.photURL? <Add /> : null}
                src={this.props.user.photoURL? this.props.user.photoURL : null}
                size={26}
                style={{ borderRadius: 2,}}
               />}
              anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
              targetOrigin={{horizontal: 'left', vertical: 'top'}}
              >
              <MenuItem value="Profile" primaryText="Profile" containerElement={<Link to="/profile"/>}  />
              <MenuItem value="AK" primaryText="Settings" />
              <MenuItem value="AZ" primaryText="Logout" onClick={this.handleLogout}/>
            </IconMenu>

        </ToolbarGroup>
      </AppBar>

        <Drawer
          containerStyle={{ backgroundColor: '#333333', top: 50, paddingTop: 25 }}
          open={this.props.navOpen}
          width={65}
        >

        {/*<MenuItem
          containerElement={<Link to=""/>}
          leftIcon={<Dashboard color={'white'} style={{ height: 26, width: 26}} />}
          />
        */}
        <MenuItem
          containerElement={<Link to=""/>}
          leftIcon={<LibraryBooks color={'white'} style={{ height: 26, width: 26}} />}
          />

        <MenuItem
          containerElement={<Link to="/timetracker"/>}
          leftIcon={<Timer color={'white'} style={{ height: 26, width: 26}} />}
          />


        <MenuItem
          containerElement={<Link to="/calendar"/>}
          leftIcon={<DateRange color={'white'} style={{ height: 26, width: 26 }}/>}
          />

        {
        this.props.user.email === "admin@mymozak.com" ?
        <MenuItem
          containerElement={<Link to="/dashboard"/>}
          leftIcon={<Dashboard color={'white'} style={{ height: 26, width: 26 }}/>}
          /> : null
        }

  
          <MenuItem
            href=" https://app.intercom.io/a/meeting-scheduler/calendar/eFpCSW9mYWlRbTNId0VZcDUzZDVLL2daNDk2QzVJblgzQVZzNlZLdHlranJ5SDhNd1p3bE9QbDVSQ0pjUFptQi0tVWhpNXRvZm1hd1JqTGNsaDdPVUgwZz09--193895cab01e6d2439a52e38f98587e6974965a3"
            target="_blank"
            leftIcon={<Schedule color={'white'} style={{ height: 26, width: 26 }}/>}
          />

        {/*
        <MenuItem
          containerElement={<Link to="/documents"/>}
          leftIcon={<PictureAsPdf color={'white'} style={{ height: 26, width: 26}} />}
          />
        */}

        {/*
        <MenuItem
          leftIcon={<VoiceChat color={'white'} style={{ height: 26, width: 26 }} onClick={this.handleToggleDirectMessages}/>}
          >
          <DirectMessages showModal={showMessages} onClose={this.handleToggleDirectMessages} user={this.props.user}/>
        </MenuItem>
        */}

        {/*
        <MenuItem
          leftIcon={<Search color={'white'} style={{ height: 26, width: 26}} onClick={this.handleToggleDocSearch}/>}
          >
          <DocumentSearchModal showModal={showDocSearch} onClose={this.handleToggleDocSearch} />
        </MenuItem>
        */}

        {/*
        <MenuItem
          containerElement={<Link to="/messenger"/>}
          leftIcon={<Message color={'white'} style={{ height: 26, width: 26}} />}
          />
        */}

        {/*<MenuItem
          containerElement={<Link to="/schedule"/>}
          leftIcon={<DateRange color={'white'} style={{ height: 26, width: 26}} />}
        />*/}

        </Drawer>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  const {user} = state.auth
  const {navOpen, smallWindow} = state.common
  return {user, navOpen, smallWindow}
}

export default connect(mapStateToProps,{logoutUser, toggleNav, toggleNavResize, initialNav })(TopNavbar);



// WEBPACK FOOTER //
// ./src/common/navbar.js